import {
    IconAreaTable,
    IconCamera,
    IconScheduleTable,
    IconTraffic,
    PersonChip,
    Traffic,
} from '../../../../../components/buttons/IconButtons';
import CustomGenericTittleIconDataChip from '../../../../../components/CustomGenericTittleIconDataChip';
import TrafficDetailsModalApp from '../Functionality/TrafficDetailsModalApp';
import FineStatusStepper from '../SubComponents/StatusFines';
import CustomCard from './../../../../../components/CustomCard';
import CustomModal from './../../../../../components/Modal/CustomModal';
import CustomChip from './../../../../../components/CustomChip';
import { colors } from '../../../../../enums/colors';
import CustomCarrousel from '../../../../../components/CustomCarrousel';
import { URL } from '../../../../../Apis/Constants';
import {
    currencyFormat,
    EMPTY_VALUES,
    getDateFormat,
    getTimeFormat
} from '../../../../../Apis/functions';
import { STATUS_MODEL } from "../../../../../enums/statusEnum";
import SpeedIndicator from "../SubComponents/SpeedIndicator";
import React from "react";
import {userType} from "../../../../../enums/userTypeEnum";
import CustomTooltip from "../../../../../components/CustomTooltip";

import PaymentOptions from './Components/PaymentOptions';
import ComponentHeaderBack from './Components/ComponentHeaderBack';
import GeofencesMap from '../../Manage/SubComponents/GeofencesMap';


/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TrafficDetailsModal = (props) => {
    const { onHide, itemSelected, t, show, setShowPaymentModal, setShowConfirmationPay, optionModal } = props;

    const {
        latLng,
        dataEvidences,
        direction,
        trafficData,
        buildEvidenceImages,
        paymentOptionsView,
        setPaymentOptionsView,
        hideButtonsModal,
        onConfirm,
        geofence,
        center,
        locations
    } = TrafficDetailsModalApp({
        itemSelected,
        optionModal,
        onHide,
        setShowConfirmationPay
    });


    return (
        <CustomModal
            {...props}
            size='lg'
            buttonConfirm={STATUS_MODEL.PAID === parseInt(trafficData?.statusId) ? "receipt": "proceed_to_payment"}
            onHide={() => {
                onHide();
            }}
            onConfirm={onConfirm}
            closeButton={paymentOptionsView ? false : true}
            confirmButton={hideButtonsModal === false }
            cancelButton={hideButtonsModal === false}
            classNameBody={'p-0 m-0'}
        >
            {paymentOptionsView ?
                <PaymentOptions
                    setPaymentOptions={setPaymentOptionsView}
                    trafficData={trafficData}
                    setShowPaymentModal={setShowPaymentModal}
                />
                :
            <>
            <div className='d-flex justify-content-between align-items-center w-100 mt-2'>
                <ComponentHeaderBack
                    title={` # ${trafficData?.folio} `}
                    classNameTitle={`fs-24px ibl-font-w-600 ml-2 font-color-general-950`}
                    trafficData={trafficData}
                    icon={ <div> <IconTraffic className='w-32px'/></div> }
                    showCustomChip={true}
                    showVerticalSeparator={true}
                />
                <div className='text-end'>
                    <p className='fs-8px font-color-general-950 ibl-font-w-500 ml-2'>{t('amount_fined')}</p>
                    <p className='font-color-error-600 ibl-font-w-400 fs-20px'>
                        {'$ ' + currencyFormat(trafficData?.paidAmount)}
                    </p>
                </div>
            </div>
            <div className="mb-3">
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <Traffic className={'w-100'} />
                <div className={'row mt-3 mb-3'}>
                    <div className={"col-sm-12 col-md-12 col-lg-4"}>
                        {<UserDetails
                            userName={trafficData?.fullName}
                            userRole={userType[trafficData?.userTypeId] ? t(userType[trafficData?.userTypeId]) : EMPTY_VALUES.DEFAULT}
                        />}
                    </div>

                    <div className={"col-sm-12 col-md-12 col-lg-8"}>
                        <div className={"d-flex justify-content-end"}>
                            <FineStatusStepper
                                statusId={trafficData?.statusId}
                                statusScheduleId={trafficData?.statusScheduleId}
                                finePaymentDate={trafficData?.finePaymentDate}
                                createdAtFine={trafficData?.createdAt}
                                discountDate={trafficData?.discountDate}
                                paymentDate={trafficData?.paymentDate}
                                suspendedAccountDate={trafficData?.suspendedAccountDate}
                                discountApplied={trafficData?.discountApplied}
                                t={t}
                            />
                        </div>
                    </div>
                </div>

                <div className={'border-bottom-shades-300'} />
                <div className='row mt-3'>
                    <div className='col-sm-12 col-md-6 mt-2 mb-2'>
                        <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                            <div className="d-flex align-items-center p-3">
                                <div className={"d-flex align-items-center mr-2"}>
                                    <IconAreaTable/>
                                </div>

                                <div className={"flex-grow-1 minw-0"}>
                                    <CustomTooltip
                                        text={trafficData?.geofenceName}
                                        classes={"font-color-general-950 ibl-font-w-600 fs-14px text-ellipsis-1-row"}
                                        showIfTruncated={true}
                                        placement={"top"}
                                    />
                                </div>
                            </div>

                            <div className={"mb-3 h-380px"}>
                                { latLng &&
                                <>
                                    <GeofencesMap
                                        id={JSON.stringify(center) + JSON.stringify(geofence?.geofenceId)}
                                        key={JSON.stringify(center) + JSON.stringify(geofence?.geofenceId)}
                                        center={center}
                                        geofences={geofence ? [geofence]: []}
                                        locations={locations}
                                        geofenceTitle='defined_areas'
                                        showTitle={false}
                                        classNameMap={"h-100"}
                                    />
                                </>
                                }

                            </div>
                            <div className="pb-3"
                                onClick={()=>{
                                    const url = `https://www.google.com/maps/search/?api=1&query=${latLng?.[0]},${latLng?.[1]}`;
                                    window.open(url, '_blank');
                                }}
                            >
                                <CustomTooltip
                                    text={direction}
                                    classes={"fs-12px ibl-font-w-400 font-color-primary-700 font-hover-primary-900 text-ellipsis-2-rows text-start pl-2"}
                                    showIfTruncated={true}
                                    placement={"top"}
                                />
                            </div>
                        </CustomCard>
                    </div>

                    <div className='col-sm-12 col-md-6 px-0'>
                        <div className={"row"}>
                            <div className={"col-sm-12 col-md-6 "}>
                                <p className='fs-14px ibl-font-w-600'>{t('infraction_date')}</p>
                                <div className={"border-bottom-shades-300 mt-1 mb-2"}/>
                                <div className={'mt-2'}>
                                    <div className={' d-flex align-items-center'}>
                                        <IconScheduleTable className="icon-color-general-950" />
                                        <p className={'font-color-general-950 fs-14px ml-2'}>
                                            {getDateFormat(trafficData?.fineDate, false)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-sm-12 col-md-6"}>
                                <p className='fs-14px ibl-font-w-600'>{t('time')}</p>
                                <div className={"border-bottom-shades-300 mt-1 mb-2"}/>
                                <div className={' d-flex align-items-center'}>
                                    <IconScheduleTable className="icon-color-general-950" />
                                    <p className={'font-color-general-950 fs-14px ml-2'}>
                                        {getTimeFormat(trafficData?.fineDate)}
                                    </p>
                                </div>
                            </div>
                        </div>


                        <div className={"row mt-4"}>
                            <div className={"col-sm-12 col-md-6"}>
                                <p className='fs-14px ibl-font-w-600'>{t('speed')}</p>
                                <div className={"border-bottom-shades-300 mt-1 mb-2"}/>
                                <SpeedIndicator
                                    speed={trafficData?.speed}
                                    speedUnit={trafficData?.speedUnit}
                                />
                            </div>
                            <div className={"col-sm-12 col-md-6"}>
                                <p className='fs-14px ibl-font-w-600'>{t('speed_limit')}</p>
                                <div className={"border-bottom-shades-300 mt-1 mb-2"}/>
                                <SpeedIndicator
                                    speed={"+ " + trafficData?.speedLimit}
                                    speedUnit={trafficData?.speedUnit}
                                />
                            </div>
                        </div>

                        <div className='row my-4'>
                            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                                <div className={'mt-3 ml-3 mb-2'}>
                                    <CustomGenericTittleIconDataChip
                                        Icon={IconCamera}
                                        title='evidence'
                                        border={false}
                                    />
                                </div>
                                <div className={'border-bottom-shades-300'} />
                                <CustomCarrousel
                                    images={buildEvidenceImages(dataEvidences, URL)}
                                    noInformationText={t('no_evidence_fine')}
                                />
                            </CustomCard>
                        </div>
                    </div>
                </div>
            </CustomCard>
            </div>
            </>
            }
        </CustomModal>
    );
};

export default TrafficDetailsModal;


const UserDetails = ({ userName = "", userRole = "" }) => {
    return (
        <div className='d-flex justify-content-center align-items-center'>
            <div className='d-flex'>
                <div className={"mr-2 d-flex align-items-center"}>
                    <PersonChip />
                </div>
                <div className={"flex-grow-1 minw-0"}>
                    <CustomTooltip
                        text={userName}
                        classes={"font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-2-rows"}
                        showIfTruncated={true}
                        placement={"top"}
                    />
                </div>
            </div>
            <div className='vertical-separator-shades-950 h-36px align-self-center'/>
            <div>
                <CustomChip
                    background={colors.secondary100}
                    borderColor={colors.secondary150}
                    fontColor={colors.secondary700}
                    legend={userRole}
                />
            </div>
        </div>
    )
}
